import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://qwqpclwyikncwktebrpd.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF3cXBjbHd5aWtuY3drdGVicnBkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg4ODczMTQsImV4cCI6MjA5NDQ2MzMxNH0.8tXckDjuukgt72QUWxJQEVs9yBc8fs7Xq3CHVOHk9Qg';

export const supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
      flowType: 'pkce',
      detectSessionInUrl: true,
      persistSession: true,
      autoRefreshToken: true,
    }
  });